import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HolidaysDetailsComponent } from './components/holidays-details/holidays-details.component';
import { HolidaysViewComponent } from './components/holidays-view/holidays-view.component';
import { DefaultComponent } from 'src/app/layouts/default/default.component';



const routes: Routes = [
    {
        path: '', component:DefaultComponent, children:[
            {
                path: '', component: HolidaysDetailsComponent
            },
            {
                path: 'details', component: HolidaysDetailsComponent
            },
            {
                path: 'view/:id' , component: HolidaysViewComponent
            }
        ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HolidaysRoutingModule { }